import { risks } from "@/data/roadmap";
import { ROADMAP } from "@/constants/testIds/roadmap";
import { SectionLabel } from "./ExecSummary";
import { AlertTriangle, Shield } from "lucide-react";

export default function Risks() {
  return (
    <section
      id="risks"
      data-testid={ROADMAP.risksSection}
      className="py-20 lg:py-28 border-b border-[#DEE2E6] bg-white"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <SectionLabel n="09" label="Risks & Mitigation" />
        <div className="grid lg:grid-cols-12 gap-6 mt-3 items-end">
          <h2 className="lg:col-span-7 font-heading text-3xl md:text-4xl lg:text-5xl tracking-tighter font-bold">
            We&apos;ve shipped enough ERPs to know where they break.
          </h2>
          <p className="lg:col-span-5 text-[#495057] leading-relaxed">
            Every known failure mode comes with a planned mitigation — and Gr8Agentic AI watches for the
            ones we haven&apos;t seen yet.
          </p>
        </div>

        <div className="mt-14 grid md:grid-cols-2 gap-0 border border-[#0A0A0A]">
          {risks.map((r, i) => {
            const isLastRow = i >= risks.length - 2;
            const isRight = (i + 1) % 2 === 0;
            return (
              <div
                key={r.risk}
                data-testid={`risk-row-${i}`}
                className={`p-6 lg:p-7 bg-white ${
                  !isLastRow ? "border-b border-[#0A0A0A]" : ""
                } ${!isRight ? "md:border-r border-[#0A0A0A]" : ""}`}
              >
                <div className="flex items-start gap-3">
                  <AlertTriangle size={16} className="text-[#D90429] flex-shrink-0 mt-1" />
                  <div className="font-heading font-semibold text-lg tracking-tight text-[#0A0A0A]">
                    {r.risk}
                  </div>
                </div>
                <div className="mt-4 flex items-start gap-3 pl-7">
                  <Shield size={14} className="text-[#0B7A75] flex-shrink-0 mt-1" />
                  <div className="text-sm text-[#495057] leading-relaxed">{r.mitigation}</div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
